import { IRootState } from 'reducers';
import { createSelector } from 'reselect';

const proforientationResultFoundSelector = createSelector(
  [(state: IRootState) => state.proforientation],
  (proforientation) => {
    return Boolean(proforientation.content?.testing?.found);
  },
);

export default proforientationResultFoundSelector;
